<div class="report-card">
  <div class="header">
    Commission Lost
    <span class="sub-header">
      {{ startDate | date: 'shortDate' }} - {{ endDate | date: 'shortDate' }}
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>

  <app-loading-swirly [isLoading]="dataLoading"></app-loading-swirly>

  @if (!dataLoading) {
    <div>
      <div class="big-header bad-text" style="text-align: left; margin-bottom: 8px;">
        <span [ngStyle]="{'color': mainColor}">{{ total | currency:'USD':'symbol':'0.0-2' }}</span>
        <span class="small">
          Total
        </span>
      </div>
      <div>
        <div class="pretend-table-row">
          <span>
            Work Order
          </span>
          <span>
            Total
          </span>
        </div>
        <div class="horizontal-line"></div>
      </div>
      @if (commissionLostRecords.length == 0) {
        <div class="fine-print" style="text-align: center;">
          No commission lost!
        </div>
      }
      @for (record of commissionLostRecords; track record; let i = $index) {
        <div>
          @if (i < 3 || showAllCommissionLost) {
            <span>
              <div class="pretend-table-row">
                <span>
                  <a target="_blank" class="regular-link" (click)="goToWorkOrder(record)">{{record.number}}</a>
                </span>
                <span>
                  {{ record.total | currency:'USD':'symbol':'0.0-2' }}
                </span>
              </div>
              <div class="horizontal-line"></div>
            </span>
          }
        </div>
      }
      @if (commissionLostRecords.length > 3 && !showAllCommissionLost) {
        <div class="regular-link" (click)="showAllCommissionLost = true">+ LOAD MORE +</div>
      }
      @if (commissionLostRecords.length > 3 && showAllCommissionLost) {
        <div class="regular-link" (click)="showAllCommissionLost = false">+ SHOW LESS +</div>
      }
    </div>
  }
</div>
